import { container } from 'tsyringe';
import Wallet from '../../../gamma-engine/slots/model/Wallet';
import SlotMachine from '../../../gamma-engine/slots/model/SlotMachine';
import ControlCommand from '../../../gamma-engine/core/control/command/ControlCommand';
import {WalletEvent} from '../../../gamma-engine/slots/model/event/WalletEvent';
import {SlotMachineState} from '../../../gamma-engine/slots/model/SlotMachineState';
import {RoundResult} from '../../../gamma-engine/slots/model/RoundResult';
import {SlotGameEvent} from '../../../gamma-engine/slots/control/event/SlotGameEvent';
import Logger from '../../../gamma-engine/core/utils/Logger';
import ControlEvent from '../../../gamma-engine/core/control/event/ControlEvent';
import GameService from '../../services/GameService';


export default class BuyFeatureCommandOverride extends ControlCommand {

    public execute(): void {
        const wallet: Wallet = container.resolve(Wallet);
        const sm: SlotMachine = container.resolve(SlotMachine);
        const gs: GameService = container.resolve<GameService>('GameService');

        const totalBet: number = gs.featureBuyConfig.Rate * sm.totalBet * wallet.coinValue;
        if (wallet.balance < totalBet) {
            if (sm.autoplay.enabled) {
                sm.autoplay.spinsLeft = 0;
                sm.autoplay.enabled = false;
            }

            sm.currentState = SlotMachineState.IDLE;
            
            // setTimeout: to handle to popups simultaneously, not enough balance on buy free spins popup
            setTimeout(() => {
                wallet.emit(WalletEvent.NOT_ENOUGH_BALANCE);
            }, 600)

            return;
        }
        if(!sm.roundResult)return;
        wallet.balance -= sm.totalBet*sm.description.coinRate;;

        sm.spinTimeLapsed = false;
        sm.reelsStarted = false;
        sm.stopRequested = false;
        sm.bigWinShown = false;

        sm.previousRoundResult = sm.roundResult;

        sm.roundResult.totalWinValue = 0;
        sm.roundResult = null;
        sm.currentState = SlotMachineState.SPINNING;

        gs.buyFeature()
            .then((roundResult: RoundResult) => {
                sm.roundResult = roundResult;
                new ControlEvent(SlotGameEvent.SPIN_STOP).dispatch();
            })
            .catch((e) => {
                Logger.error(e);
                sm.roundResult = sm.getDummyRoundResult(sm.previousRoundResult);
                wallet.balance += totalBet;
                sm.currentState = SlotMachineState.COMMUNICATION_ERROR;
            });
    }
}
